import { gql } from 'graphql-tag'

export const GET_DATA_HEALTH_CHECK_DETAIL_QUERY = gql`
  query GET_DATA_HEALTH_CHECK_DETAIL_QUERY(
    $check: GetDataHealthCheckInputDto!
  ) {
    getDataHealthCheckDetail(check: $check) {
      status
      data
      total
      query {
        dimensions
      }
      explorerListView {
        measure
        columns
        filters {
          member
          operator
          values
        }
      }
    }
  }
`
